import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const ContainerFAQ = styled.div`
  padding: 10px;
`;

export const ContainerQuestion = styled.div<{ open: boolean }>`
  padding: 18px;
  background-color: ${({ open }) => (open ? colors.brand.primary.lighter : 'white')};
  border: 1px solid ${({ open }) => (open ? colors.text['primary-base'] : colors.bg['soft-200'])};
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 0 0 4px 0 #00000026;
  cursor: pointer;
  div {
    p {
      margin-bottom: 0;
      font-size: 12px;
    }
    ul {
      margin-bottom: 0;
      font-size: 12px;
    }
  }
`;

export const HeaderFAQ = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  h1 {
    font-size: 20px;
  }
  p {
    color: ${colors.text['soft-400']};
    font-size: 12px;
  }
`;

export const HeaderQuestion = styled.div<{ rotate: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
    gap: 8px;
    div {
      gap: 2px;
      display: flex;
      flex-wrap: nowrap;
    }
    h2 {
      font-size: 16px;
      font-weight: 600;
      color: ${colors.text['main-900']};
      margin: 0;
    }
    span {
      font-size: 16px;
      font-weight: 600;
      color: ${colors.text['main-900']};
      margin: 0;
      flex-wrap: nowrap;
      display: flex;
    }
  }
  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    svg {
      rotate: calc(${(props) => props.rotate});
    }
  }
`;

export const ContainerArea = styled.div`
  min-width: 80px;
  display: flex;
  align-items: center;
  margin-top: 3px;
  border: 1px solid ${colors.bg['soft-200']};
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  gap: 5px;
  margin-bottom: 20px;
`;

export const Footer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  width: auto;
  p {
    color: ${colors.text['sub-500']};
    font-size: 12px;
    margin-bottom: 2px;
  }
  span {
    color: ${colors.text['primary-base']};
    font-size: 11px;
    font-weight: 600;
  }
  div {
    display: flex;
    gap: 4px;
    cursor: pointer;
    margin-top: 4px;
  }
  img {
    width: 16px;
    height: 16px;
  }
`;
